import { render, staticRenderFns } from "./BuyingStationOrderBulkImport.vue?vue&type=template&id=93b483cc&scoped=true"
import script from "./BuyingStationOrderBulkImport.vue?vue&type=script&lang=js"
export * from "./BuyingStationOrderBulkImport.vue?vue&type=script&lang=js"
import style0 from "./BuyingStationOrderBulkImport.vue?vue&type=style&index=0&id=93b483cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b483cc",
  null
  
)

export default component.exports